import { AllowedReaderConnectorTypes } from './allowed-connector-types';
import { NODE_TYPES } from './node-types';
import validateConstraintConsistency from './validateConstraintConsistency';

const commandConstraints = {
  [NODE_TYPES.printCommand]: {
    acceptedParentNodes: [
      // commands
      NODE_TYPES.selectCommand,
      NODE_TYPES.executeCommand,
      NODE_TYPES.insertCommand,
      NODE_TYPES.updateCommand,
      NODE_TYPES.validateCommand,
      // dataframes
      NODE_TYPES.select,
      NODE_TYPES.insert,
      NODE_TYPES.update,
      // all read connectors are allowed
      ...AllowedReaderConnectorTypes,
    ],
    acceptedChildNodes: [],
  },
  [NODE_TYPES.selectCommand]: {
    acceptedParentNodes: [
      NODE_TYPES.selectCommand,
      NODE_TYPES.executeCommand,
      NODE_TYPES.insertCommand,
      NODE_TYPES.updateCommand,
      NODE_TYPES.validateCommand,
      // dataframes
      NODE_TYPES.select,
      NODE_TYPES.insert,
      NODE_TYPES.update,
      // all read connectors are allowed
      ...AllowedReaderConnectorTypes,
    ],
    acceptedChildNodes: [NODE_TYPES.selectCommand],
  },
  [NODE_TYPES.insertCommand]: {
    acceptedParentNodes: [
      NODE_TYPES.selectCommand,
      NODE_TYPES.executeCommand,
      NODE_TYPES.insertCommand,
      NODE_TYPES.updateCommand,
      NODE_TYPES.validateCommand,
      // dataframes
      NODE_TYPES.select,
      NODE_TYPES.insert,
      NODE_TYPES.update,
      // all read connectors
      ...AllowedReaderConnectorTypes,
    ],
    acceptedChildNodes: [],
  },
  [NODE_TYPES.deleteCommand]: {
    acceptedParentNodes: [
      NODE_TYPES.selectCommand,
      // all read connectors
      ...AllowedReaderConnectorTypes,
    ],
    acceptedChildNodes: [],
  },
  [NODE_TYPES.updateCommand]: {
    acceptedParentNodes: [
      NODE_TYPES.selectCommand,
      // all read connectors
      ...AllowedReaderConnectorTypes,
    ],
    acceptedChildNodes: [],
  },
  [NODE_TYPES.printSchemaCommand]: {
    acceptedParentNodes: [
      NODE_TYPES.selectCommand,
      NODE_TYPES.executeCommand,
      NODE_TYPES.insertCommand,
      NODE_TYPES.updateCommand,
      NODE_TYPES.validateCommand,
      // all read connectors
      ...AllowedReaderConnectorTypes,
    ],
    acceptedChildNodes: [],
  },
  [NODE_TYPES.executeCommand]: {
    acceptedParentNodes: [
      // batch tasks
      NODE_TYPES.dataOperationbatch,
      // sftp tasks
      // directory list task
      NODE_TYPES.sftpOperationdirectoryList,
      // copy task
      NODE_TYPES.sftpOperationcopyFile,
      NODE_TYPES.sftpOperationcopyFileToS3,
      // move task
      NODE_TYPES.sftpOperationmoveFile,
      // delete task
      NODE_TYPES.sftpOperationdeleteFile,
      NODE_TYPES.sftpOperationdeleteFileFromS3,
    ],
    acceptedChildNodes: [],
  },
};

let Constraints = {
  ...commandConstraints,
};

(() => {
  const { errors, fixedConstraints } = validateConstraintConsistency({
    constraints: Constraints,
    allowedReaderConnectorTypes: AllowedReaderConnectorTypes,
  });
  Constraints = fixedConstraints;
})();

export { Constraints };
